<template>
  <a-form ref="formRef" :model="postParams" v-bind="layout">
    <a-row>
      <a-col :span="16">
        <a-form-item label="KEY值" name="globalKey" :labelCol="{ span: 2 }">
          <a-input
            v-model:value="globalKey"
            placeholder="仅支持全局搜索"
            allowClear
          />
        </a-form-item>
      </a-col>
      <a-col :span="2" :offset="1">
        <a-button
          type="primary"
          @click="handleGlobalSearch"
          :disabled="globalKey === ''"
          >全局查询</a-button
        >
      </a-col>
    </a-row>
    <a-row :gutter="[16]">
      <a-col :span="8">
        <a-form-item label="KEY值" name="itemKey">
          <a-input
            v-model:value="postParams.itemKey"
            placeholder="请输入"
            @change="
              e =>
                inputLengthCut({
                  val: e.target.value,
                  key: 'itemKey',
                  len: 255
                })
            "
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="Basics" name="defaultValue">
          <a-input
            v-model:value="postParams.defaultValue"
            placeholder="请输入编码"
            @change="
              e =>
                inputLengthCut({
                  val: e.target.value,
                  key: 'defaultValue',
                  len: 10
                })
            "
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: right;">
          <a-space>
            <a-button type="default" @click="resetParams">重置</a-button>
            <a-button type="primary" @click="resetPagination">查询</a-button>
            <a-upload
              v-model:file-list="fileList"
              name="file"
              :multiple="true"
              :customRequest="uploadHandleChange"
            >
              <a-button type="defalut">批量维护</a-button>
            </a-upload>
          </a-space>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
import { formRequest } from 'cupshe-axios'
import { message } from 'ant-design-vue'
export default {
  setup() {
    const initData = inject('initState')
    const state = reactive({
      fileList: [],
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
      },
      uploadHandleChange: async info => {
        if (info && info.file) {
          const { data, success, retInfo } = await formRequest(
            `${process.env.VUE_APP_I18N}i18n/value/import/${initData.postParams.siteCode}`,
            {
              file: [info.file]
            }
          )
          if (success) {
            console.log(data)
            message.success('上传成功')
            info.onSuccess(retInfo, info)
            state.fileList = []
            initData.resetPagination()
          } else {
            message.error(retInfo)
            info.onError(retInfo)
            state.fileList = []
          }
        }
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
